export default "__VITE_ASSET__a998bd78__"